import { enumPanelBorderStyle, kDownArrow, kReturnKey, kTabKey, kUpArrow } from "../constants";
import { QDropDownElement } from "./QDropDownElement";
import { QPanel } from "./QPanel";

export class QDropDownViewPort extends QPanel {
  constructor() {
    super();
    this.fBackgroundPanel = null;
  }

  GetListID() {
    return this.fBackgroundPanel.GetListID();
  }

  InitPortPanel(parentPanel, roundBorders) {
    this.fBackgroundPanel = parentPanel;
    this.fWSMgr = parentPanel.fWSMgr;
    var panelFill = parentPanel.GetFillColor();
    this.SetFillColor(panelFill);
    if (roundBorders) {
      this.SetBorderThickness(2);
      this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
      this.SetBorderRadius(4);
    }
    var parentZLayer = parentPanel.GetZLayer();
    this.SetZLayer(parentZLayer);
    this.fZPlanes = [];
  }

  SizePanel(hPort, vPort, hSize, vSize) {
    if (hSize == null) hSize = hPort;
    if (vSize == null) vSize = vPort;
    this.SizePanelAndPort(hSize, vSize, hPort, vPort);
  }

  ExecuteCommand(aCmd) {
    return this.fBackgroundPanel.ExecuteCommand(aCmd);
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var handled;
    var keyCode = keyInfo.keyCode;
    switch (keyCode) {
      case kReturnKey:
        var aCmd = this.fWSMgr.AssembleCommand(targetElement, this, null);
        handled = this.fBackgroundPanel.ExecuteCommand(aCmd);
        break;
      case kUpArrow:
      case kTabKey:
      case kDownArrow:
        handled = true;
        this.ArrowKeyNavigation(QDropDownElement, keyCode);
        break;
      default:
        handled = this.fBackgroundPanel.PanelHandleKeyboard(keyInfo, targetElement, wsMgr);
        break;
    }

    return handled;
  }

  GetFirstSelectedBox(includeTextBox) {
    return null;
  }

  IsMainPanel() {
    return true;
  }

  DoCustomCopy(clipBoard) {}
}
